export default "__VITE_ASSET__BLrI3o84__"